/**
 *
 * ColorPickerModal
 *
 */

import React from "react";
import Modal from "react-modal";

import ColorPicker from "components/ColorPicker";
import { Label } from "components/InputField/styledComponents";

const ColorPickerModal = ({ close, modalProps }) => {
  const { onChange, siblingRef, hex = "", label } = modalProps;

  const { top, left } = siblingRef
    ? siblingRef.getBoundingClientRect()
    : { top: 0, left: 0 };
  const width = siblingRef.offsetWidth;

  return (
    <Modal
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      isOpen={true}
      style={{
        content: {
          top,
          left,
          display: "table",
          border: "none",
          background: "transparent",
          padding: 0,
          borderRadius: 3,
          width,
        },
        overlay: {
          zIndex: 1,
          background: "transparent",
        },
      }}
      contentLabel="color picker"
    >
      <Label marginTop={-7}>{label}</Label>
      <ColorPicker
        color={hex}
        onChange={(c) => {
          onChange(c);
        }}
      />
    </Modal>
  );
};

export default ColorPickerModal;
